import { Product } from "../models/product";
import { useFormContext } from "react-hook-form";
import { DrawerSubHeader } from "../../../components/DrawerSubHeader";
import { TextInput } from "../../../components/forms/inputs/TextInput";
import { Divider } from "../../../components/Divider";

type Props = {
  index: number;
};

export const UpdatePackingItemForm = ({ index }: Props) => {
  const methods = useFormContext<Product & { files: File[] }>();

  const packingItem = methods.watch(`packagingInstructions.${index}`);
  return (
    <>
      <DrawerSubHeader header={packingItem.title} subtext={packingItem.name} />
      <Divider />
      <TextInput
        name={`packagingInstructions.${index}.amount`}
        label="Amount"
        helperText="The amount of the packing item in the product"
      />
    </>
  );
};
